import axios from "axios";
import config from "./config";

const baseURL = config.API_URL;

const AxiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 35000,
  headers: {
    Accept: "application/json",
    Authorization: "Bearer ",
    "Content-Type": "multipart/form-data",
  },
});

AxiosInstance.interceptors.request.use(
  async (config: any) => {
    axios.defaults.timeout = 35000;
    config.baseURL = baseURL;
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = "Bearer ".concat(token);
    }
    return config;
  },
  (error) => Promise.reject(error.response.data)
);


AxiosInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  (errors) => {
    return errors.response.data;
  }
);


export default AxiosInstance;
